var _defs, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMusica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 79.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5656ff;}.cls-2{fill:none;stroke:#5656ff;stroke-miterlimit:10;stroke-width:2.15px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.46,34,16.82,47.71a6.41,6.41,0,0,0-.21,8.83h0a6.41,6.41,0,0,0,9.32.21L39.34,43.17a19.14,19.14,0,0,1-5.7-3.93A14,14,0,0,1,30.46,34Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.13,
    cy: 26.42,
    r: 13.99
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.61,56.54c-3.31,2.89-4.15,9.11-.89,12.74,4.65,5.2,15,4.61,26.09-6.84,8.46-8.71,17.27-11,24.53.54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusica);
export default __webpack_public_path__ + "static/media/Icon-musica.1c109506c0ef2d3963f22ce270ab0018.svg";
export { ForwardRef as ReactComponent };